<template>
    <div class="wx_warp" v-if="show">
        <div class="warp_border">
            <div class="messageBox" :style="{'width':width}">
                <slot name='content'></slot>
                <div class="btns">
                    <el-button class="save" @click="save">{{btnTitles[0]}}</el-button>
                    <el-button class="canse" @click="canse">{{btnTitles[1]}}</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "messageBox",
        model: {
            prop: 'show'
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            width:{
                type: String,
                default: '450px'
            },
            btnTitles: {
                type: Array,
                default() {return ['确定','取消']}
            },
        },
        data(){
            return{

            }
        },
        methods:{
            save(){
                this.$emit('save','');
            },
            canse(){
                this.$emit('canse','');
            }
        },
        watch:{
            show: {
                immediate: true, // 很重要！！！
                handler (val) {
                    if(val){
                        document.getElementsByTagName('body')[0].className = 'overhidden'
                    }else{
                        document.body.removeAttribute('class')
                    }
                }
            }
        }
    }
</script>

<style lang="less">
    .wx_warp{
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;
        background: rgba(0,0,0,0.7);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
        .warp_border{
            background-image: url("../assets/images/home/box_up_left.png"),
            url("../assets/images/home/box_up_right.png"),
            url("../assets/images/home/box_down_left.png"),
            url("../assets/images/home/box_down_right.png");
            background-repeat: no-repeat, no-repeat, no-repeat, no-repeat;
            background-position: top left, top right, bottom left, bottom right;
            padding: 3px;
        }
        .messageBox{
            min-height: 291px;
            max-height: 875px;
            background: #fff;
            width: 450px;
            background: linear-gradient(180deg, #0D2258 0%, #0D1C45 100%);
            border: 1px solid #2D99FF;
            border-radius: 20px;
            .word{
                font-size: 20px;
                font-weight: 400;
                color: #A0D1FF;
                button{
                    width: 160px;
                    height: 37px;
                    line-height: 37px;
                    border: 1px solid #2D99FF;
                    font-size: 20px;
                    color: #A0D1FF;
                    text-align: center;
                    margin-top: 15px;
                    background-color: transparent;
                    cursor: pointer;
                }
            }
            .btns{
                margin: 50px auto 40px auto;
                .el-button{
                    width: 150px;
                    height: 48px;
                    line-height: 48px;
                    background: #2D99FF;
                    border-radius: 4px;
                    border: 0;
                    padding: 0;
                    font-size: 18px;
                    font-weight: 400;
                    color: #fff;
                    text-align: center;
                }
                .canse{
                    margin-left: 30px;
                    background: #00A1E6;
                }
            }
            .wx_form{
                margin-top: 45px;
                .wx_top{
                    margin-bottom: 5px;
                    .avatar-uploader {
                        width: 70px;
                        height: 70px;
                        border-radius: 6px;
                        border: 1px solid rgba(45, 153, 255, 0.48);
                        margin: 0 auto;
                        .el-upload{
                            width: 70px;
                            height: 70px;
                        }
                        .unloadIcon {
                            width: 70px;
                            height: 70px;
                            position: relative;
                            &:after{
                                content: '';
                                width: 41px;
                                height: 41px;
                                background: url("../assets/images/upLoad_02.png") no-repeat;
                                background-size: cover;
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                margin-top: -20.5px;
                                margin-left: -20.5px;
                            }
                        }
                    }
                }
                .form_item{
                    display: flex;
                    align-items: center;
                    margin-top: 10px;
                    padding-left: 60px;
                    .label{
                        width: 100px;
                        font-size: 16px;
                        font-weight: 400;
                        color: #fff;
                        text-align: left;
                    }
                    .w110{
                        width: 110px;
                    }
                    .el-select{
                        width: 230px;
                    }
                    .el-input{
                        width: 230px;
                    }
                    .w106{
                        width: 106px;
                    }
                    .w70{
                        width: 70px;
                        .el-input{
                            width: 100%;
                        }
                    }
                    .w100{
                        width: 100px;
                        .el-input{
                            width: 100%;
                        }
                    }
                    .subLabel{
                        font-size: 18px;
                        color: #fff;
                        padding-left: 10px;
                    }
                    .el-input__inner{
                        text-align: left;
                        font-size: 14px;
                    }
                    .tip{
                        font-size: 14px;
                        font-weight: 400;
                        color: #fff;
                        padding-left: 12px;
                    }
                    .paddLeft{
                        width: 73px;
                        padding-left: 20px;
                    }
                }
                .flexTop{
                    align-items: flex-start;
                }
                .lable_tips{
                    font-size: 16px;
                    color: #fff;
                    padding: 16px 0 16px 60px;
                    text-align: left;
                    span{
                        color: #D0D0D0;
                    }
                }
            }
            .marTop97{
                margin-top: 97px;
            }
            .copyDetail{
                padding: 0 33px;
                p{
                    font-size: 18px;
                    font-weight: 400;
                    color: #A0D1FF;
                    line-height: 30px;
                    text-align: left;
                }
                .form_item{
                    display: flex;
                    justify-items: center;
                    align-items: center;
                    padding: 12px 0;
                    .lable{
                        width: 95px;
                        font-size: 18px;
                        font-weight: 400;
                        color: #A0D1FF;
                    }
                    .el-input__inner{
                        text-align: left;
                        font-size: 14px;
                    }
                }
            }
            .addPartition{
                padding: 35px 0 0 60px;
                .form_item{
                    display: flex;
                    justify-items: center;
                    align-items: center;
                    padding: 12px 0;
                    .lable{
                        width: 181px;
                        font-size: 16px;
                        font-weight: 400;
                        color: #A0D1FF;
                        text-align: left;
                    }
                    .subLabel{
                        font-size: 18px;
                        color: #fff;
                        padding-right: 5px;
                    }
                    .el-input{
                        width: 230px;
                    }
                    .el-input__inner{
                        text-align: left;
                        font-size: 14px;
                        color: #D0D0D0;
                    }
                    .label_tips{
                        font-size: 16px;
                        color: #fff;
                        padding-left: 14px;
                        span{
                            color: #D0D0D0;
                        }
                    }
                    .paddL{
                        padding-left: 24px;
                    }
                    .w60{
                        margin-right: 12px;
                        .el-input{
                            width: 60px;
                            position: relative;
                            &:after{
                                content: '。';
                                font-size: 18px;
                                color: #fff;
                                position: absolute;
                                top: -18px;
                                right: -18px;
                            }
                        }
                    }
                }
                .bot_tips{
                    text-align: left;
                    font-size: 16px;
                    font-weight: 400;
                    color: #B3B3B3;
                }
            }
            .edit_box{
                padding-top: 88px;
                .form_item{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .lable{
                        width: 106px;
                        height: 28px;
                        font-size: 20px;
                        font-weight: 400;
                        color: #A0D1FF;
                    }
                    .input{
                        width: 112px;
                        margin: 0 12px;
                    }
                    .label_tips{
                        font-size: 20px;
                        font-weight: 400;
                        color: #A0D1FF;
                    }
                }
            }
            .cycle_box{
                padding: 45px 60px 0 60px;
                .label{
                    font-size: 20px;
                    font-weight: 400;
                    color: #A0D1FF;
                    text-align: left;
                }
                .el-radio-group{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-wrap: wrap;
                    .el-radio{
                        margin-top: 30px;
                        &:last-child{
                            margin-right: 30px;
                        }
                    }
                }
            }
            .pestDamage{
                margin-top: 45px;
                .form_item{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 25px;
                    .label{
                        width: 135px;
                        font-size: 16px;
                        font-weight: 400;
                        color: #fff;
                        text-align: left;
                    }
                    .el-select{
                        width: 195px;
                    }
                    .el-input{
                        width: 195px;
                    }
                    .el-input__inner{
                        text-align: left;
                        font-size: 14px;
                    }

                    .addBtn{
                        font-size: 16px;
                        font-weight: 400;
                        color: #00A1E6;
                        cursor: pointer;
                    }
                    .w266{
                        width: 266px;
                    }
                    .tip{
                        font-size: 14px;
                        font-weight: 400;
                        color: #fff;
                        padding-left: 12px;
                    }
                }
                .lable_tips{
                    font-size: 16px;
                    color: #fff;
                    padding: 16px 0 16px 60px;
                    text-align: left;
                    span{
                        color: #D0D0D0;
                    }
                }
            }
            .import{
                padding: 39px 0 0 60px;
                .label{
                    font-size: 16px;
                    color: #fff;
                    padding-bottom: 20px;
                    text-align: left;
                }
                .item{
                    display: flex;
                    align-items: center;
                    margin-bottom: 25px;
                    .item_label{
                        width: 98px;
                        font-size: 16px;
                        color: #fff;
                        text-align: left;
                    }
                    .input{
                        width: 260px;
                        .el-select{
                            width: 100%;
                        }
                    }
                    .wx_radio{
                        text-align: left;
                        .el-radio-group{
                            display: flex;
                            align-items: center;
                        }
                        .el-radio__label{
                            font-size: 16px;
                        }
                    }
                }
                .bottom_label{
                    font-size: 16px;
                    color: #A0D1FF;
                    padding-right: 60px;
                    text-align: left;
                }
            }
            .addTask{
                .item {
                    .item_label {
                        width: 135px;
                        font-size: 16px;
                        color: #fff;
                        text-align: left;
                    }
                    .input{
                        width: 195px;
                        .el-select{
                            width: 100%;
                        }
                        .el-date-editor{
                            width: 100%;
                        }
                        .el-input__inner{
                            text-align: center;
                            font-size: 14px;
                        }
                    }
                }
            }
            .personnel{
                padding: 45px 60px 0 60px;
                .item_label{
                    font-size: 20px;
                    color: #A0D1FF;
                    text-align: left;
                }
                .radio_box{
                    .el-checkbox-group{
                        display: flex;
                        flex-wrap: wrap;
                        .el-checkbox{
                            margin-top: 20px;
                            margin-right: 20px;
                            &:last-child{
                                //margin-right: 30px;
                            }
                        }
                    }
                }
            }
            .editTime{
                display: flex;
                justify-content: center;
                align-items: center;
                padding-top: 85px;
                .label{
                    font-size: 20px;
                    color: #A0D1FF;
                    padding-right: 10px;
                }
            }
            .edit_security{
                padding: 55px 25px 0 25px;
                .form_item{
                    display: flex;
                    align-items: center;
                    margin-bottom: 25px;
                    .lable{
                        width: 130px;
                        font-size: 20px;
                        font-weight: 400;
                        color: #A0D1FF;
                        padding-right: 10px;
                        text-align: right;
                    }
                    .input{
                        width: 260px;
                        .el-input__inner{
                            text-align: left;
                            font-size: 14px;
                        }
                    }
                    .code{
                        display: flex;
                        align-items: center;
                        .el-input{
                            width: 176px;
                        }
                        .el-button{
                            width: 100px;
                            height: 28px;
                            line-height: 28px;
                            background: #2D99FF;
                            border: 0;
                            border-radius: 0;
                            font-size: 14px;
                            padding: 0;
                            color: #fff;
                            text-align: center;
                            cursor: pointer;
                        }
                    }
                }

            }
            .flexMessageBox{
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
                .form_item{
                    align-items: flex-start;
                    justify-content: flex-start;
                    .lable{
                        width: 140px;
                        padding-top: 5px;
                        font-size: 16px;
                        text-align: right;
                        padding-right: 10px;
                    }
                    .billie{
                        display: flex;
                    }
                    .el-input{
                        width: 200px;
                    }
                    .w96{
                        width: 96px;
                    }
                    .input_obj{
                        width: 560px;
                        .el-checkbox__label{
                            color: #fff;
                        }
                        .el-form-item__content{
                            text-align: left;
                        }
                        .el-checkbox{
                            &:last-of-type{
                                margin-right: 30px;
                            }
                        }
                    }
                }
                .img_item{
                    width: 100%;
                    .el-upload{
                        width: 100px;
                        height: 100px;
                        background: rgba(45, 153, 255, 0.3);
                        border-radius: 0;
                        border: 0;
                        .crop{
                            width: 100px;
                            height: 100px;
                            position: relative;
                            &:before{
                                content: '';
                                width: 70px;
                                height: 65px;
                                background: url("../assets/images/upLoad_04.png") no-repeat;
                                background-size: cover;
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                margin-left: -35px;
                                margin-top: -32.5px;
                                z-index: 1;
                            }
                            &:after{
                                content: '';
                                width: 41px;
                                height: 41px;
                                background: url("../assets/images/upLoad_02.png") no-repeat;
                                background-size: cover;
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                margin-left: -20.5px;
                                margin-top: -20.5px;
                                z-index: 2;
                            }
                            img{
                                width: 100%;
                            }
                        }
                    }
                    .el-upload-list--picture-card .el-upload-list__item{
                        width: 100px;
                        height: 100px;
                        background: rgba(45, 153, 255, 0.3);
                        border-radius: 0;
                        border: 0;
                    }
                }

            }
            .tableBox{
                .top{
                    padding: 15px 20px;
                    display: flex;
                    justify-content: space-between;
                    .closse{
                        width: 64px;
                        height: 23px;
                        line-height: 23px;
                        border-radius: 2px;
                        border: 1px solid #10FFCA;
                        font-size: 14px;
                        font-weight: 500;
                        color: #10FFCA;
                        text-align: center;
                        cursor: pointer;
                    }
                }
                .wx_table{
                    padding: 0 30px;
                    tr{
                        td{
                            text-align: center;
                        }
                    }
                }
            }
        }
        .word{
            margin-top: 88px;
        }
        .marTop{
            margin-top: 65px;
        }
        .marTop44{
            margin-top: 44px;
        }
    }

</style>
